<template>
  <div>
    <fileManage-list v-show="tabType === 1" @handleShow="handleShow" />
    <fileManage-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import fileManageList from './list.vue'
import fileManageShow from './show.vue'
export default {
  components: { fileManageList, fileManageShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>